export default "__VITE_ASSET__CQYJNzUj__"